const currentFaceplateOption = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_FACEPLATE_OPTION':
            return {
                ...state,
                leftOption: action.payload,
                rightOption: action.payload
            };
        case 'SET_LEFT_FACEPLATE_OPTION':
            return {
                ...state,
                leftOption: action.payload
            };
        case 'SET_RIGHT_FACEPLATE_OPTION':
            return {
                ...state,
                rightOption: action.payload
            };
        default:
            return state;
    }
};

export default currentFaceplateOption;
